---
title: Computational social science is a production problem
slug: computational-social-science
type: thinking-note
status: published
featured: true
summary: Each wave of invention creates benefits that are not obvious at the time. The useful work is modeling living networks — and then serving those models as predictions.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2017-11-01"
lastReviewedAt: "2026-09-18"
audiences:
  - business
themes:
  - computational-social-science
  - interaction-science
sourceUrl: https://jayvanzyl.me/about/computational-social-science/
originalAuthor: Jay van Zyl
sourceRelationship: rewritten from the original first-party computational social science page
rightsStatus: first-party
seoDescription: Jay van Zyl on computational social science as models of living networks that have to be served in production.
canonicalPath: /thinking/computational-social-science
---

There is always a group facing backward, remembering how the world used to work, and a group facing forward, trying to read the next platform. Each wave of invention creates benefits that are not obvious at the time. The social science of how those inventions spread is the part that matters.

We now have computational power and human-behavior data at a scale that changes competition. People have become collection and consumption machines. Novelty is used to create recurrent interaction. A mobile app or a polished frontend is not a strategy.

Computational social science is the field that treats those living networks as something we can model — and then serve as predictions. That last clause is the whole product argument. A paper that cannot become a score in an interaction is unfinished work.
